import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { getWidgetProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { isOmissisEnabled } from '../../directives/omissis/OmissisDirective.type.tsx';
import { ButtonsLayout } from './components/ButtonsLayout.tsx';
import { UploadWidgetReadonlyComponentInput } from './components/UploadWidgetReadonlyComponentInput.tsx';
import { type IUploadWidget, UploadButtonsLayout } from './IUploadWidget.ts';
import { publicDataUploadWidgetName } from './UploadWidget.type.tsx';

type IUploadWidgetReadonlyComponentProps = IWidgetComponentProps<IUploadWidget>;

/**
 * Componente di upload in modalità readonly
 * @param props
 * @returns
 */
export function UploadWidgetReadonlyComponent(
  props: IUploadWidgetReadonlyComponentProps,
) {
  const options = getWidgetProps(props);

  const privateWidgetName = options.name;
  const publicWidgetName = publicDataUploadWidgetName(options.name);
  const omissisEnabled = isOmissisEnabled(props.widget);

  return (
    <ButtonsLayout
      hasOmissis={omissisEnabled}
      horizontal={
        props.widget.layout?.buttonLayout == UploadButtonsLayout.Horizontal
      }
    >
      <UploadWidgetReadonlyComponentInput
        {...props}
        widgetName={privateWidgetName}
      />
      {omissisEnabled && (
        <UploadWidgetReadonlyComponentInput
          {...props}
          widgetName={publicWidgetName}
          publicUpload
        />
      )}
    </ButtonsLayout>
  );
}
